import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './DonatePage.module.css'; // Reuse some styles for consistency
import { trackEvent } from '../utils/analytics';
import { useMediaQuery } from '../hooks/useMediaQuery';
// Logo is used directly in src attribute: <img src="/logo.png" ... />

function SuccessPage() {
  // Track donation completion with Google Analytics
  useEffect(() => {
    trackEvent(
      'Donation',
      'Donation Completed',
      'Success Page',
      0 // We don't know the actual amount here
    );
  }, []);

  // Use media query hooks for responsive design
  const isMobile = useMediaQuery('(max-width: 480px)');

  const linkStyle = {
    display: 'block',
    width: isMobile ? '100%' : '80%',
    maxWidth: '300px',
    margin: '10px auto',
    padding: '12px 20px',
    textAlign: 'center',
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '4px',
    textDecoration: 'none',
    fontWeight: '500',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease'
  };

  const secondaryLinkStyle = {
    ...linkStyle,
    backgroundColor: '#3498db', // A nice blue for secondary actions
    marginTop: '15px'
  };

  const linkHoverStyle = { // Define hover style for JS-styled links
    opacity: 0.85,
    transform: 'translateY(-1px)'
  };


  return (
    <div className={styles.donatePageContainer}>
      <div className={styles.logoContainer}>
        <img src="/logo.png" alt="Shul Logo" className={styles.logo} />
      </div>
      <h1>Thank You!</h1>
      <div className={styles.successMessage}>
        Your donation has been processed successfully.
      </div>
      <p style={{
        textAlign: 'center',
        marginTop: '20px',
        fontSize: isMobile ? '0.9rem' : '1rem',
        padding: '0 10px',
        lineHeight: '1.6',
        color: '#555'
      }}>
        We appreciate your generous support. A receipt will be sent to your email if provided.
      </p>
      <div style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Link 
          to="/" 
          style={linkStyle}
          onMouseOver={(e) => e.currentTarget.style.opacity = linkHoverStyle.opacity }
          onMouseOut={(e) => e.currentTarget.style.opacity = 1 }
        >
          Return to Homepage
        </Link>
        <Link 
          to="/donate" 
          style={secondaryLinkStyle}
          onMouseOver={(e) => e.currentTarget.style.opacity = linkHoverStyle.opacity }
          onMouseOut={(e) => e.currentTarget.style.opacity = 1 }
        >
          Make Another Donation
        </Link>
      </div>
    </div>
  );
}

export default SuccessPage;
